// extracted by mini-css-extract-plugin
var _1 = "CommentReactionList-module__active--MDfBP";
var _2 = "CommentReactionList-module__animatedBackground--_Uvds";
var _3 = "CommentReactionList-module__container--GrGmH";
var _4 = "CommentReactionList-module__count--ro_MP";
var _5 = "CommentReactionList-module__item--OgX8F";
export { _1 as "active", _2 as "animatedBackground", _3 as "container", _4 as "count", _5 as "item" }
